<div
  class="simple-notification"
  [@enterLeave]="item.state"
  (click)="onClick($event)"
  [class]="theClass"
  [ngClass]="{
    alert: item.type === 'alert',
    error: item.type === 'error',
    warn: item.type === 'warn',
    success: item.type === 'success',
    info: item.type === 'info',
    bare: item.type === 'bare',
    'rtl-mode': rtl,
    'has-icon': item.icon !== 'bare',
  }"
  (mouseenter)="onEnter()"
  (mouseleave)="onLeave()"
>
  @if (!item.html) {
    <div>
      @if (titleIsTemplate) {
        <div class="sn-title">
          <ng-container
            *ngTemplateOutlet="title; context: item.context"
          ></ng-container>
        </div>
      } @else {
        <div class="sn-title" [innerHTML]="title"></div>
      }
      @if (contentIsTemplate) {
        <div class="sn-content">
          <ng-container
            *ngTemplateOutlet="content; context: item.context"
          ></ng-container>
        </div>
      } @else {
        <div class="sn-content" [innerHTML]="content"></div>
      }
      @if (item.icon !== 'bare') {
        <div class="icon" [innerHTML]="safeSvg"></div>
      }
    </div>
  }
  @if (item.html) {
    <div>
      @if (htmlIsTemplate) {
        <div class="sn-html">
          <ng-container
            *ngTemplateOutlet="item.html; context: item.context"
          ></ng-container>
        </div>
      } @else {
        <div class="sn-content" [innerHTML]="safeInputHtml"></div>
      }
      @if (item.icon) {
        <div
          class="icon"
          [class.icon-hover]="clickIconToClose"
          [innerHTML]="safeSvg"
          (click)="onClickIcon($event)"
        ></div>
      }
    </div>
  }

  @if (showProgressBar) {
    <div class="sn-progress-loader">
      <span [ngStyle]="{ width: progressWidth + '%' }"></span>
    </div>
  }
</div>
